/**
 * Action types for Flux
 * @module
 */
var keyMirror = require('keymirror');

/**
 * @enum {string}
 */
module.exports = keyMirror({
  // Internal
  LOG: null,
  SET_LOGLEVEL: null,

  // Activate
  INITIALIZE_STATE: null,
  SET_DOMCONTENTLOADED: null,

  // Activate
  ACTIVATE: null,

  // Behavior
  UPDATE_BEHAVIOR_STORE: null,

  // DATA
  DATA_LOADED: null,

  // Client Metadata
  SET_CLIENT_NAME: null,
  SET_CLIENT_VERSION: null,

  // Layer
  LOAD_PERSISTED_LAYER_STATES: null,

  // Decision
  RECORD_GLOBAL_DECISION: null,
  RECORD_LAYER_DECISION: null,

  // History
  ENSURE_ORIGINAL_PUSHSTATE: null,
  ENSURE_ORIGINAL_REPLACESTATE: null,

  // Visitor
  SET_VISITOR_ATTRIBUTES: null,
  SET_VISITOR_ATTRIBUTE_PENDING: null,
  LOAD_EXISTING_VISITOR_PROFILE: null,
  SET_VISITOR_EVENTS: null,
  SET_FOREIGN_VISITOR_EVENTS: null,
  SET_FOREIGN_VISITOR_EVENT_QUEUE: null,
  SET_VISITOR_ID: null,
  SET_VISITOR_ID_VIA_API: null,
  SET_GA4_USER_ID: null,
  REFRESH_SESSION: null,
  LOAD_SESSION_STATE: null,

  UPDATE_VARIATION_ID_MAP: null,
  MERGE_VARIATION_ID_MAP: null,

  UPDATE_PREFERRED_LAYER_MAP: null,
  MERGE_PREFERRED_LAYER_MAP: null,

  UPDATE_CONTEXTUAL_MAB_MAP: null,
  MERGE_CONTEXTUAL_MAB_MAP: null,

  SET_ODP_SEGMENTS: null,

  // Analytics
  RECORD_LAYER_DECISION_EVENT_ID: null,
  TRACK_VIEW_ACTIVATED_EVENT: null,

  // Async
  REGISTER_ASYNC_DEFERRED: null,
  RESOLVE_DEFERRED: null,
  REJECT_DEFERRED: null,

  // Plugin registration actions
  REGISTER_PLUGIN: null,

  // Cleanup
  ADD_CLEANUP_FN: null,
  CLEAR_CLEANUP_FN: null,

  // Action message types
  ACTION_EXECUTED: null,
  REGISTER_ACTION: null,

  // View messages
  SET_VIEW_ACTIVE_STATE: null,
  UPDATE_PARSED_VIEW_METADATA: null,
  UPDATE_USER_SUPPLIED_METADATA: null,
  REGISTER_VIEWS: null,
  SET_GLOBAL_TAGS: null,
  SET_VIEW_BATCHING: null,
  RESET_VIEW_STATES: null,

  // Event stream message types
  ATTACH_EVENT_STREAM_PUBLISHERS: null,
  DETACH_EVENT_STREAM_PUBLISHERS: null,

  // Directive messages
  LOAD_DIRECTIVE: null,

  // Cookie
  SET_COOKIE_AGE: null,
  SET_COOKIE_DOMAIN: null,
  SET_COOKIE_AUTO_REFRESH: null,

  // X-domain
  XDOMAIN_SET_DEFAULT_FRAME: null,
  XDOMAIN_ADD_FRAME: null,
  XDOMAIN_SET_MESSAGE: null,
  XDOMAIN_ADD_SUBSCRIBER: null,
  XDOMAIN_SET_CANONICAL_ORIGINS: null,
  XDOMAIN_SET_DISABLED: null,

  // Event Emitter
  ADD_EMITTER_HANDLER: null,
  REMOVE_EMITTER_HANDLER: null,

  SET_INTEGRATION_SETTINGS: null,

  // Change data
  ADD_CHANGE: null,

  // Action data
  SET_CHANGE_APPLIER: null,
  REMOVE_ACTION_STATE: null,

  // Redirect reporting
  ANNOUNCE_PENDING_REDIRECT: null,
  LOAD_REDIRECT_DATA: null,
  REGISTER_TRACKED_REDIRECT_DATA: null,

  // Pending events
  SET_PENDING_EVENT: null,
  REMOVE_PENDING_EVENT: null,
  LOAD_PENDING_EVENTS: null,

  // Sandboxed functions
  SANDBOXED_FUNCTIONS_ADDED: null,

  // RUM data
  SET_RUM_DATA: null,
  RECORD_API_USAGE: null,
  INITIALIZE_CHANGE_METRICS: null,
  RECORD_ACTIVATION_TYPE_USAGE: null,
  RECORD_AUDIENCE_USAGE: null,
  RECORD_CHANGE_MACROTASK_RATE: null,
  RECORD_CHANGE_OVERHEATED: null,
  RECORD_CHANGE_TYPE_USAGE: null,
  RECORD_DOM_OBSERVATION_OCCURENCE: null,
  RECORD_INTEGRATION_USAGE: null,
  RECORD_LAYER_FEATURE_USAGE: null,
  RECORD_LAYER_POLICY_USAGE: null,
  RECORD_RECOMMENDATIONS_USAGE: null,
  RECORD_VIEW_FEATURE_USAGE: null,
  RECORD_VIEWS_INITIALLY_ACTIVATED_COUNT: null,
  RECORD_VISITOR_ID_LOCATOR_USAGE: null,
  RECORD_VISITOR_ID_ERROR: null,
  RECORD_STICKY_BUCKETING_FEATURE: null,

  // PERF data initialized
  SET_PERFORMANCE_MARKS_DATA: null,

  //Optimizely tracker data
  FINALIZE_BATCH_SNAPSHOT: null,
  REGISTER_PREVIOUS_BATCH: null,
  REGISTER_TRACKER_VISITOR: null,
  REGISTER_TRACKER_EVENT: null,
  REGISTER_TRACKER_DECISION: null,
  RESET_TRACKER_EVENTS: null,
  RESET_TRACKER_PREVIOUS_BATCHES: null,
  RESET_TRACKER_STORE: null,
  SET_TRACKER_POLLING: null,
  SET_TRACKER_BATCHING: null,
  SET_TRACKER_USE_BEACON: null,
  SET_TRACKER_SEND_EVENTS: null,
  SET_TRACKER_PERSISTABLE_STATE: null,
  SET_TRACKER_DIRTY: null,
  UPDATE_TRACKER_VISITOR_ATTRIBUTES: null,

  // UA store
  SET_UA_DATA: null,
});
